<template>
  <v-autocomplete
    color="primary"
    v-model="selected"
    :clearable="!unclearable"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :label="$t('Search.searchUse')"
    return-object
    hide-details
    style="margin-left: auto; margin-right: auto"
    hide-no-data
    item-value="link"
    item-text="title"
    cache-items
  >
    <template v-slot:item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title>{{ data.item.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ data.item.module }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import consts from "@/consts";

export default {
  name: "SearcherMaterial",

  props: {
    unclearable: Boolean,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "allow", "accountUser"]),
  },

  data: () => ({
    loading: false,
    search: null,
    selected: null,
    items: [],
  }),

  mounted() {},

  watch: {
    search(val) {
      if (val) this.querySelections(val);
    },
    selected: {
      handler() {
        if (this.selected) {
          var routerUrl = this.$router.resolve({ path: this.selected.link });
          if (this.selected.intelligenceReportsUrl) {
            window.open(this.selected.link);
          } else {
            if (this.selected.target) {
              window.open(routerUrl.href, this.selected.target);
            } else {
              window.open(routerUrl.href, "_self");
            }
          }

          this.$emit("selected");
        }
      },
    },
  },
  methods: {
    makeItems() {
      var nav = [];
      var navItems = this.navs();
      if (this.allow) {
        navItems.forEach((item) => {
          if (!item.controller) {
            nav.push(item);
          } else {
            let controller = this.allow[item.controller];
            if (controller) {
              if (
                controller.find((action) => item.action == action) &&
                (!item.show || item.show())
              ) {
                nav.push(item);
              }
            }
          }
        });
      }
      return nav;
    },
    navs() {
      return [
        {
          title: i18n.t("Nav.orderManagement"),
          link: "/orders",
          module: i18n.t("Nav.orderManagement"),
          controller: "Orders",
          action: "index",
        },
        {
          title: i18n.t("Nav.orderNew"),
          link: "/order-new",
          module: i18n.t("Nav.orderManagement"),
          controller: "Orders",
          action: "index",
          show: function () {
            return this.$permission.permissionAllow("Orders", "add");
          }.bind(this),
        },
        {
          title: i18n.t("Nav.orders"),
          link: "/orders",
          module: i18n.t("Nav.orderManagement"),
          controller: "Orders",
          action: "index",
        },
        {
          title: i18n.t("Nav.ordersApprove"),
          link: "/orders-approve",
          module: i18n.t("Nav.orderManagement"),
          controller: "Orders",
          action: "approval",
          show: function () {
            return (
              this.settings &&
              (!this.settings.process_order ||
                (this.settings.process_order &&
                  (this.settings.process_order.indexOf(2) > -1 ||
                    this.settings.process_order.indexOf("2") > -1)))
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.ordersStockOrdersOut"),
          link: "/order-stock-out",
          module: i18n.t("Nav.orderManagement"),
          controller: "StockOuts",
          action: "index",
          show: function () {
            return (
              this.settings &&
              (!this.settings.process_order ||
                (this.settings.process_order &&
                  (this.settings.process_order.indexOf(3) > -1 ||
                    this.settings.process_order.indexOf("3") > -1)))
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.distributions"),
          link: "/distributions",
          module: i18n.t("Nav.orderManagement"),
          controller: "Distributions",
          action: "index",
          show: function () {
            return (
              this.settings &&
              (!this.settings.process_order ||
                (this.settings.process_order &&
                  (this.settings.process_order.indexOf(4) > -1 ||
                    this.settings.process_order.indexOf("4") > -1)))
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.examines"),
          link: "/examines",
          module: i18n.t("Nav.orderManagement"),
          controller: "Examines",
          action: "index",
          show: function () {
            return (
              this.settings &&
              (!this.settings.process_order ||
                (this.settings.process_order &&
                  (this.settings.process_order.indexOf(5) > -1 ||
                    this.settings.process_order.indexOf("5") > -1)))
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.purchases"),
          link: "/purchases",
          module: i18n.t("Nav.purchases"),
          controller: "Purchases",
          action: "index",
        },
        {
          title: i18n.t("Nav.stockout"),
          link: "/purchase/stockout",
          module: i18n.t("Nav.purchases"),
          controller: "Purchases",
          action: "short",
        },
        {
          title: i18n.t("Nav.intelligentPurchase"),
          link: "/intelligent-purchase",
          module: i18n.t("Nav.purchases"),
          controller: "Purchases",
          action: "getIntelligentPurchaseDetails",
        },
        {
          title: i18n.t("Nav.purchasesList"),
          link: "/purchases",
          module: i18n.t("Nav.purchases"),
          controller: "Purchases",
          action: "index",
        },
        {
          title: i18n.t("Nav.purchasesExamine"),
          link: "/purchases-examine",
          module: i18n.t("Nav.purchases"),
          controller: "Purchases",
          action: "index",
          show: function () {
            return this.$permission.permissionAllow(
              "Purchases",
              "examineHistory"
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.supplier"),
          link: "/supplier",
          module: i18n.t("Nav.purchases"),
          controller: "Suppliers",
          action: "index",
        },
        {
          title: i18n.t("Nav.quotation"),
          link: "/quotations",
          module: i18n.t("Nav.purchases"),
          controller: "Quotations",
          action: "index",
        },
        {
          title: i18n.t("Nav.economy"),
          link: "/economies",
          module: i18n.t("Nav.purchases"),
          controller: "Economies",
          action: "index",
        },
        {
          title: i18n.t("Nav.returnOrderManagement"),
          link: "/return-orders",
          module: i18n.t("Nav.returnOrderManagement"),
          controller: "ReturnOrders",
          action: "index",
        },
        {
          title: i18n.t("Nav.returnOrderNew"),
          link: "/return-order-new",
          module: i18n.t("Nav.returnOrderManagement"),
          controller: "ReturnOrders",
          action: "index",
          show: function () {
            return this.$permission.permissionAllow("ReturnOrders", "add");
          }.bind(this),
        },
        {
          title: i18n.t("Nav.returnOrders"),
          link: "/return-orders",
          module: i18n.t("Nav.returnOrderManagement"),
          controller: "ReturnOrders",
          action: "index",
        },
        {
          title: i18n.t("Nav.returnOrdersApprove"),
          link: "/return-orders-approve",
          module: i18n.t("Nav.returnOrderManagement"),
          controller: "ReturnOrders",
          action: "index",
          show: function () {
            return (
              this.$permission.permissionAllow("ReturnOrders", "approval") &&
              this.settings &&
              (!this.settings.process_return_order ||
                (this.settings.process_return_order &&
                  (this.settings.process_return_order.indexOf(2) > -1 ||
                    this.settings.process_return_order.indexOf("2") > -1)))
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.stockManagement"),
          link: "/stocks",
          module: i18n.t("Nav.stockManagement"),
          controller: "Stocks",
          action: "index",
        },
        {
          title: i18n.t("Nav.currentStocks"),
          link: "/current-stocks",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockCurrents",
          action: "index",
        },
        {
          title: i18n.t("Nav.currentPosition"),
          link: "/current-position",
          module: i18n.t("Nav.stockManagement"),
          controller: "PositionCurrents",
          action: "index",
          show: function () {
            return this.settings && this.settings.stock_position_setting;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.movePositionOrder"),
          link: "/move-position-order",
          module: i18n.t("Nav.stockManagement"),
          controller: "PositionMoves",
          action: "index",
          show: function () {
            return this.settings && this.settings.stock_position_setting;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.stocks"),
          link: "/stocks",
          module: i18n.t("Nav.stockManagement"),
          controller: "Stocks",
          action: "index",
        },
        {
          title: i18n.t("Nav.requisitions"),
          link: "/requisitions",
          module: i18n.t("Nav.stockManagement"),
          controller: "Requisitions",
          action: "index",
        },
        {
          title: i18n.t("Nav.stockTakeOrders"),
          link: "/stock-take-orders",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockTakes",
          action: "index",
        },
        {
          title: i18n.t("Nav.stockOrdersIn"),
          link: "/stock-orders-in",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockIns",
          action: "index",
        },
        {
          title: i18n.t("Nav.putaway"),
          link: "/putaway",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockIns",
          action: "getWaitShelveOnList",
          show: function () {
            return this.settings && this.settings.stock_position_setting;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.stockOrdersOut"),
          link: "/stock-orders-out",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockOuts",
          action: "index",
        },
        {
          title: i18n.t("Nav.waveGenerate"),
          link: "/wave-generate",
          module: i18n.t("Nav.stockManagement"),
          controller: "Waves",
          action: "add",
          show: function () {
            return this.settings && this.settings.stock_position_setting;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.waves"),
          link: "/waves",
          module: i18n.t("Nav.stockManagement"),
          controller: "Waves",
          action: "index",
          show: function () {
            return this.settings && this.settings.stock_position_setting;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.waitOutMaterialAnalyses"),
          link: "/wait-out-material-analyses",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockOuts",
          action: "waitOutMaterialAnalyses",
        },
        {
          title: i18n.t("Nav.stockOrderAnalyze"),
          link: "/stock-order-analyze",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockOrderAnalyze",
          action: "index",
        },
        {
          title: i18n.t("Nav.shopPsi"),
          link: "/shop-psi",
          module: i18n.t("Nav.stockManagement"),
          controller: "Shops",
          action: "shopPsi",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.stockBatch"),
          link: "/stock-details",
          module: i18n.t("Nav.stockManagement"),
          controller: "StockDetails",
          action: "index",
        },
        {
          title: i18n.t("Nav.productionManagement"),
          link: "/auto-split-production",
          module: i18n.t("Nav.productionManagement"),
          controller: "ProductionPlans",
          action: "index",
          show: function () {
            return this.settings && this.settings.production_module;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.autoSplitProduction"),
          link: "/auto-split-production",
          module: i18n.t("Nav.productionManagement"),
          controller: "ProductionPlans",
          action: "autoSplitStockIns",
          show: function () {
            return this.settings && this.settings.production_module;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.productionPlans"),
          link: "/production-plans",
          module: i18n.t("Nav.productionManagement"),
          controller: "ProductionPlans",
          action: "index",
          show: function () {
            return this.settings && this.settings.production_module;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.productionStockOUT"),
          link: "/production-stock-out",
          module: i18n.t("Nav.productionManagement"),
          controller: "ProductionPlans",
          action: "outs",
          show: function () {
            return this.settings && this.settings.production_module;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.productionStockIN"),
          link: "/production-stock-in",
          module: i18n.t("Nav.productionManagement"),
          controller: "ProductionPlans",
          action: "ins",
          show: function () {
            return this.settings && this.settings.production_module;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.materialManagement"),
          link: "/materials",
          module: i18n.t("Nav.materialManagement"),
          controller: "Materials",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialCategories"),
          link: "/material-categories",
          module: i18n.t("Nav.materialManagement"),
          controller: "MaterialCategories",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialShowCategories"),
          link: "/material-show-categories",
          module: i18n.t("Nav.materialManagement"),
          controller: "MaterialShowCategories",
          action: "add",
          show: function () {
            return (
              this.settings &&
              this.settings.miniprogram &&
              (this.settings.miniprogram.template_id == "4" ||
                this.settings.miniprogram.template_id == "3")
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.materials"),
          link: "/materials",
          module: i18n.t("Nav.materialManagement"),
          controller: "Materials",
          action: "index",
        },
        {
          title: i18n.t("Nav.units"),
          link: "/unit",
          module: i18n.t("Nav.materialManagement"),
          controller: "Configs",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialTemplates"),
          link: "/templates",
          module: i18n.t("Nav.materialManagement"),
          controller: "Templates",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialOrderRules"),
          link: "/material-order-rules",
          module: i18n.t("Nav.materialManagement"),
          controller: "OrderRulers",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialCampaign"),
          link: "/material-campaigns",
          module: i18n.t("Nav.materialManagement"),
          controller: "MaterialCampaigns",
          action: "index",
        },
        {
          title: i18n.t("Nav.campaign"),
          link: "/campaign",
          module: i18n.t("Nav.materialManagement"),
          controller: "Campaigns",
          action: "index",
          show: function () {
            return this.settings && this.settings.campaign_use_setting == 2;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.materialCoupons"),
          link: "/material-coupons",
          module: i18n.t("Nav.materialManagement"),
          controller: "Coupons",
          action: "index",
        },
        {
          title: i18n.t("Nav.dishManagement"),
          link: "/dishes",
          module: i18n.t("Nav.dishManagement"),
          controller: "Foods",
          action: "index",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.dishCategories"),
          link: "/dish-categories",
          module: i18n.t("Nav.dishManagement"),
          controller: "FoodCategories",
          action: "index",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.dishes"),
          link: "/dishes",
          module: i18n.t("Nav.dishManagement"),
          controller: "Foods",
          action: "index",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.recipeManagement"),
          link: "/recipes",
          module: i18n.t("Nav.dishManagement"),
          controller: "FoodFormula",
          action: "index",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.dishTemplates"),
          link: "/dish-templates",
          module: i18n.t("Nav.dishManagement"),
          controller: "FoodTemplates",
          action: "index",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.shopManagement", [consts.shopName()]),
          link: "/shops",
          module: i18n.t("Nav.shopManagement", [consts.shopName()]),
          controller: "Shops",
          action: "index",
        },
        {
          title: i18n.t("Nav.alliances", [consts.allianceName()]),
          link: "/alliances",
          module: i18n.t("Nav.shopManagement", [consts.shopName()]),
          controller: "AllianceBusinesses",
          action: "index",
        },
        {
          title: i18n.t("Nav.shops", [consts.shopName()]),
          link: "/shops",
          module: i18n.t("Nav.shopManagement", [consts.shopName()]),
          controller: "Shops",
          action: "index",
        },
        {
          title: i18n.t("Nav.districts"),
          link: "/districts",
          module: i18n.t("Nav.shopManagement", [consts.shopName()]),
          controller: "Districts",
          action: "index",
        },
        {
          title: i18n.t("Nav.registers"),
          link: "/registers",
          module: i18n.t("Nav.shopManagement", [consts.shopName()]),
          controller: "Registers",
          action: "index",
        },
        {
          title: i18n.t("Nav.customerMaintenance"),
          link: "/qacenter",
          module: i18n.t("Nav.customerMaintenance"),
          controller: "Qacenter",
          action: "index",
        },
        {
          title: i18n.t("Nav.complaint"),
          link: "/qacenter",
          module: i18n.t("Nav.customerMaintenance"),
          controller: "Qacenter",
          action: "index",
        },
        {
          title: i18n.t("Nav.announcement"),
          link: "/announcement",
          module: i18n.t("Nav.customerMaintenance"),
          controller: "Announcements",
          action: "index",
        },
        {
          title: i18n.t("Nav.accountAds"),
          link: "/account-ads",
          module: i18n.t("Nav.customerMaintenance"),
          controller: "AccountAds",
          action: "index",
        },
        {
          title: i18n.t("Nav.fundManagement"),
          link: "/receipts",
          module: i18n.t("Nav.fundManagement"),
          controller: "Receipt",
          action: "index",
        },
        {
          title: i18n.t("Nav.capital"),
          link: "/capital",
          module: i18n.t("Nav.fundManagement"),
          controller: "Shops",
          action: "getShopBalanceHistories",
        },
        {
          title: i18n.t("Nav.capitalHistory"),
          link: "/account-history",
          module: i18n.t("Nav.fundManagement"),
          controller: "Shops",
          action: "getShopBalanceHistories",
        },
        {
          title: i18n.t("Nav.receipt"),
          link: "/receipts",
          module: i18n.t("Nav.fundManagement"),
          controller: "Receipt",
          action: "index",
        },
        {
          title: i18n.t("Nav.inanceReceipt"),
          link: "/finance-bills",
          module: i18n.t("Nav.fundManagement"),
          controller: "FinanceBills",
          action: "index",
          show: function () {
            return (
              this.settings &&
              this.settings.finance_bill_enable &&
              this.settings.finance_bill_enable == "1"
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.paymentBatch"),
          link: "/payment-batch",
          module: i18n.t("Nav.fundManagement"),
          controller: "Receipt",
          action: "batchReceiveAndPay",
        },
        {
          title: i18n.t("Nav.receiptHistory"),
          link: "/receipt-history",
          module: i18n.t("Nav.fundManagement"),
          controller: "Receipt",
          action: "history",
        },
        {
          title: i18n.t("Nav.payment"),
          link: "/payment",
          module: i18n.t("Nav.fundManagement"),
          controller: "Payment",
          action: "getPaySettings",
        },
        {
          title: i18n.t("Nav.receiptBillAnalyze"),
          link: "/receipt-bill-analyze",
          module: i18n.t("Nav.fundManagement"),
          controller: "Receipt",
          action: "billAnalyze",
        },
        {
          title: i18n.t("Nav.thirdPayment"),
          link: "/huifu",
          module: i18n.t("Nav.thirdPayment"),
          controller: "ThirdAccountInfo",
          action: "index",
        },
        {
          title: i18n.t("Nav.huifuAccount"),
          link: "/huifu",
          module: i18n.t("Nav.thirdPayment"),
          controller: "ThirdAccountInfo",
          action: "index",
        },
        {
          title: i18n.t("Nav.huifuPay"),
          link: "/huifu-pay",
          module: i18n.t("Nav.thirdPayment"),
          controller: "ThirdAccountInfo",
          action: "index",
        },
        {
          title: i18n.t("Nav.huifuCash"),
          link: "/huifu-cash",
          module: i18n.t("Nav.thirdPayment"),
          controller: "ThirdAccountInfo",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.settings"),
          link: "/settings/bussiness-settings",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "businessSetting",
        },
        {
          title: i18n.t("SettingNav.organization"),
          link: "/settings/organizations",
          module: i18n.t("SettingNav.settings"),
          controller: "Organizations",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.roles"),
          link: "/settings/roles",
          module: i18n.t("SettingNav.settings"),
          controller: "Roles",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.accountUsers"),
          link: "/settings/account-users",
          module: i18n.t("SettingNav.settings"),
          controller: "AccountUsers",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.processSetting"),
          link: "/settings/process-settings",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "processSetting",
        },
        {
          title: i18n.t("SettingNav.businessSetting"),
          link: "/settings/bussiness-settings",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "businessSetting",
        },
        {
          title: i18n.t("SettingNav.overSellSetting"),
          link: "/settings/over-sell-settings",
          module: i18n.t("SettingNav.settings"),
          controller: "AvailableStockMaterials",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.smsPushSetting"),
          link: "/settings/sms-push-setting",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "pushSetting",
        },
        {
          title: i18n.t("SettingNav.miniProgramSetting"),
          link: "/settings/mini-program-settings",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "miniprogramSetting",
        },
        {
          title: i18n.t("SettingNav.miniDevelopProgram"),
          link: "/settings/mini-develop-program",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "businessSetting",
          show: function () {
            return this.accountUser.type == 1;
          }.bind(this),
        },
        {
          title: i18n.t("SettingNav.thirdApiSetting"),
          link: "/settings/third-api-setting",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "thirdApiSetting",
          show: function () {
            return this.accountUser.type == 1;
          }.bind(this),
        },
        {
          title: i18n.t("SettingNav.logisticsSetting"),
          link: "/settings/logistics-setting",
          module: i18n.t("SettingNav.settings"),
          controller: "Logistics",
          action: "view",
        },
        {
          title: i18n.t("SettingNav.logisticsApiSetting"),
          link: "/settings/logistics-api-setting",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "logisticsApiSetting",
        },
        {
          title: i18n.t("SettingNav.otherSetting"),
          link: "/settings/other-settings",
          module: i18n.t("SettingNav.settings"),
          controller: "Settings",
          action: "otherSetting",
        },
        {
          title: i18n.t("SettingNav.reportDesign"),
          link: "/settings/print-templates",
          module: i18n.t("SettingNav.reportDesign"),
          controller: "PrintTemplates",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.subAccountSettings"),
          link: "/settings/sub-account-settings/sub-account-type",
          module: i18n.t("SettingNav.subAccountSettings"),
          controller: "SubAccountSettings",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.subAccountType"),
          link: "/settings/sub-account-settings/sub-account-type",
          module: i18n.t("SettingNav.subAccountSettings"),
          controller: "SubAccountSettings",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.subAccount"),
          link: "/settings/sub-account-settings/sub-account",
          module: i18n.t("SettingNav.subAccountSettings"),
          controller: "SubAccounts",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.subAccountSettingPort"),
          link: "/settings/sub-account-settings/sub-account-setting-port",
          module: i18n.t("SettingNav.subAccountSettings"),
          controller: "SubAccountSettings",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.subAccountConfig"),
          link: "/settings/sub-account-settings/sub-account-configs",
          module: i18n.t("SettingNav.subAccountSettings"),
          controller: "SubAccountConfigs",
          action: "index",
          show: function () {
            return this.settings && this.settings.push_platform == 2001;
          }.bind(this),
        },
        {
          title: i18n.t("SettingNav.accountLogs"),
          link: "/settings/account-logs",
          module: i18n.t("SettingNav.accountLogs"),
          controller: "AccountLogs",
          action: "index",
        },
        {
          title: i18n.t("SettingNav.manageAccountLogs"),
          link: "/settings/account-logs",
          module: i18n.t("SettingNav.accountLogs"),
          controller: "AccountLogs",
          action: "index",
          show: function () {
            return this.settings && this.settings.intelligent_report == 1;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.reportDownloads"),
          link: "/report-downloads",
          module: i18n.t("Nav.reportCenter"),
          target: "_blank",
          controller: "ReportDownloads",
          action: "index",
        },
        // 报表
        {
          title: i18n.t("Nav.materialSales"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/material-sales"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "MaterialSales",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialDistribution"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/distribution-material-analyze"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "DistributionMaterialAnalyze",
          action: "index",
        },
        {
          title: i18n.t("Nav.shopSales", [consts.shopName()]),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/shop-sales"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "ShopSales",
          action: "index",
        },
        {
          title: i18n.t("Nav.distributionShopAnalyze", [consts.shopName()]),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/distribution-shop-analyze"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "DistributionShopAnalyze",
          action: "index",
        },
        {
          title: i18n.t("Nav.orderProfit"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/order-profit"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "OrderProfit",
          action: "index",
        },
        {
          title: i18n.t("Nav.billProfit"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/bill-profit"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "OrderProfit",
          action: "billCostAnalyze",
        },
        {
          title: i18n.t("Nav.shopProfit", [consts.shopName()]),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/shop-profit"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "ShopProfit",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialProfit"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/material-profit"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "MaterialProfit",
          action: "index",
        },
        {
          title: i18n.t("Nav.monthlyStatisticss"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/monthly-statisticss"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "OrderMaterialAnalyze",
          action: "monthAnalyze",
        },
        {
          title: i18n.t("Nav.orderBacklog"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/order-backlog"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "OrderMaterialAnalyze",
          action: "orderBacklog",
        },
        {
          title: i18n.t("Nav.orderFreight"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/order-freight"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "OrderMaterialAnalyze",
          action: "orderFreight",
        },
        {
          title: i18n.t("Nav.shopDailyReports", [consts.shopName()]),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/shop-daily-reports"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "ShopDailyReports",
          action: "index",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.shopCostAnalyze", [consts.shopName()]),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/shop-cost-analyze"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "ShopCostAnalyze",
          action: "index",
        },
        {
          title: i18n.t("Nav.materialCostAnalyze"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/material-cost-analyze"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "ShopCostAnalyze",
          action: "materialAnalyze",
        },
        {
          title: i18n.t("Nav.subAccountAnalyses"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/sub-account-analyses"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "SubAccountAnalyses",
          action: "index",
          show: function () {
            return this.settings && this.settings.sub_account_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.subAccountQuery"),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/sub-account-orders"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "SubAccountAnalyses",
          action: "subAccountOrders",
          show: function () {
            return this.settings && this.settings.sub_account_enable;
          }.bind(this),
        },
        {
          title: i18n.t("Nav.shopSubAccountSum", [consts.shopName()]),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/shop-sub-account-sum"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "SubAccountAnalyses",
          action: "mfSubAccount",
          show: function () {
            return (
              this.settings &&
              this.settings.sub_account_enable &&
              this.settings.push_platform == 2001
            );
          }.bind(this),
        },
        {
          title: i18n.t("Nav.alliancesSubAccounts", [
            consts.shopName(),
            consts.allianceName(),
          ]),
          link:
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/alliance-sub-accounts"),
          module: i18n.t("Nav.intelligenceReports"),
          intelligenceReportsUrl: true,
          controller: "SubAccountAnalyses",
          action: "mfShopSale",
          show: function () {
            return this.settings && this.settings.push_platform == 2001;
          }.bind(this),
        },
      ];
    },

    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = this.makeItems().filter((e) => {
          return e.title.indexOf(v) > -1;
        });
        this.loading = false;
      }, 500);
    },
  },
};
</script>
